import './client-details.scss'

import { useMachine } from '@xstate/react'
import { useEffect } from 'react'

import {
  GenericValidationMessages,
  Icon,
  IconButton,
  SaveSuccessMessage,
  Space
} from '@/components/core-v2'

import { DfmsState } from '../clients/dfm.state'
import { DfmEditor } from './dfm-editor'
import { editDfmMachine } from './state/edit-dfm-machine.state'

export const dfmSaveSuccessMessage = 'Portfolio manager saved successfully!'

export function EditDfm({ dfmState, onSave }: { dfmState: DfmsState; onSave: () => void }) {
  const [machine, send] = useMachine(editDfmMachine)
  const state = machine.context

  useEffect(() => {
    send({ type: 'INIT', dfm: dfmState.selectedDfm, onSave })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dfmState.selectedDfm])

  return (
    <>
      <DfmEditor
        dfmName={dfmState.selectedDfm?.dfmName}
        errors={state.errors}
        onMutate={mutation => send({ type: 'MUTATE', mutation })}
      />
      <GenericValidationMessages errorMessages={state.errorMessages} />
      <Space isflex alignItems="center" mb={6} mx={5}>
        <IconButton
          disabled={!state.isSaveEnabled}
          icon={<Icon name="save" size="default" />}
          iconPosition="left"
          operationType="progress"
          text="Save portfolio manager"
          onClick={() =>
            send({
              type: 'SAVE',
              dfm: { dfmName: state.dfm?.dfmName, dfmId: dfmState.selectedDfm?.dfmId }
            })
          }
        />
        <Space ml={5}>
          <SaveSuccessMessage isVisible={dfmState.isDfmSavedSuccessfully}>
            {dfmSaveSuccessMessage}
          </SaveSuccessMessage>
        </Space>
      </Space>
    </>
  )
}
